import React from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { PRODUCT_ADMIN_HOME_PATH } from "../../../Route/urlPaths";
import { LOGIN_API } from "../../../Api";
import Loader from "../../components/Loader";
import { generateSessionId } from "../../../Utils/helper";
import secureLocalStorage from "react-secure-storage";
import Modal from "../../../UiComponents/Modal";
import { BranchAndFinyearForm } from "../../components";
import useLogout, { loginSocket } from "../../../CustomHooks/useLogout";
import loginbg from "../../../assets/costinglogin.png"

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const Login = () => {
  useLogout()

  const [isGlobalOpen, setIsGlobalOpen] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [verifyname,setVerifyName] = useState("")
  const [planExpirationDate, setPlanExpirationDate] = useState("");
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(300)

  useEffect(() => {
    let timer;
    if (isOpen) {
      setTimeLeft(300); 
      timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setIsOpen(false);
            alert("Popup closed automatically after 5 minutes.");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer); 
  }, [isOpen]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs.toString().padStart(2, "0")}`;
  };
  const data = { username, password,otp,verifyname };

  const loginUser = (e) => {
    e.preventDefault();
    axios({
      method: "post",
      url: BASE_URL + LOGIN_API,
      data: data,
    }).then(
      (result) => {
        console.log(result?.data?.userInfo?.username,"result")
        if (result.status === 200) {
          if (result.data.statusCode === 2) {
            setVerifyName(result?.data?.userInfo?.username)
            console.log(verifyname,"verifyname")
            setIsOpen(true)
        }
        
          if (result.data.statusCode === 0) {
            loginSocket(result?.data?.userInfo?.id)
            sessionStorage.setItem("sessionId", generateSessionId());
            secureLocalStorage.setItem(
              sessionStorage.getItem("sessionId") + "token",
              result.data.token
            );
            if (!result.data.userInfo.roleId) {
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "userId",
                result.data.userInfo.id
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "username",
                result.data.userInfo.username
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "superAdmin",
                true
              );
              navigate(PRODUCT_ADMIN_HOME_PATH);
            } else {
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "employeeId",
                result.data.userInfo.employeeId
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "userId",
                result.data.userInfo.id
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "username",
                result.data.userInfo.username
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "userEmail",
                result.data.userInfo.email
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "userCompanyId",
                result.data.userInfo.role.companyId
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "defaultAdmin",
                JSON.stringify(result.data.userInfo.role.defaultRole)
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "userRoleId",
                result.data.userInfo.roleId
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") +
                "latestActivePlanExpireDate",
                new Date(
                  result.data.userInfo.role.company.Subscription[0].expireAt
                ).toDateString()
              );
              secureLocalStorage.setItem(
                sessionStorage.getItem("sessionId") + "userRole",
                result.data.userInfo.role.name
              );
              setIsGlobalOpen(true);
            }
          } else {
            toast.warning(result.data.message);
            setLoading(false);
          }
        }
        console.log("result", result.data.data);
      },
      (error) => {
        console.log(error);
        toast.error("Server Down", { autoClose: 5000 });
        setLoading(false);
      }
    );
  };

  return (
    <>
      <Modal
        isOpen={isGlobalOpen}
        onClose={() => {
          setIsGlobalOpen(false);
        }}
        widthClass={""}
      >
        <BranchAndFinyearForm setIsGlobalOpen={setIsGlobalOpen} fromLogin />
      </Modal>

      <div className="flex justify-start items-center flex-col h-screen">
        <img className="absolute w-full h-full" alt="" src={loginbg} />
        <div className="relative w-full h-full">
          <div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay backdrop:blur-sm">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="relative w-full max-w-xs">
                  <form
                    className="p-6 mb-4 backdrop-blur-xl rounded-lg"
                    onSubmit={loginUser}
                  >
                    <div className="mb-4">
                      <label
                        className="block text-[#388087] text-md font-bold mb-2"
                        htmfor="username"
                      >
                        Username
                      </label>
                      <input
                        onChange={(e) => setUsername(e.target.value)}
                        value={username}
                        className="shadow bg-white appearance-none border rounded w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                        id="username"
                        type="text"
                        placeholder="Username"
                        required
                      />
                    </div>
                    <div className="mb-6">
                      <label
                        className="block text-[#388087] text-md font-bold mb-2"
                        htmfor="password"
                      >
                        Password
                      </label>
                      <input
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                        className="shadow bg-white appearance-none border rounded w-full py-2 px-3 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                        id="password"
                        type="password"
                        placeholder="******************"
                        required
                      />
                    </div>
                    <div className="flex items-center justify-between">
                      <button
                        className="bg-[#388087] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="submit"
                      >
                        Sign In
                      </button>
                      {/* <p className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-gray-700 ">
                        Forgot Password?
                      </p> */}
                    </div>
                    <p className="mt-6 text-center text-[#46c2ce] text-xs">
                      &copy;{new Date().getFullYear()} Pinnale Systems All rights reserved.
                    </p>
                  </form>
                </div>



  
    {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-lg p-6 w-80">
            <h2 className="text-lg font-bold mb-4">OTP Verification</h2>
            <p className="text-sm text-gray-500 mb-4">
              Time left: <span className="font-bold">{formatTime(timeLeft)}</span>
            </p>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
              className="border w-full p-2 rounded mb-4"
            />
            <div className="flex justify-between">
              <button
                onClick={loginUser}
                className="bg-green-500 text-white px-4 py-2 rounded"
              >
                Verify
              </button>
              <button
                onClick={() => setIsOpen(false)}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
